/**
 * Types of products offered by Phuture Finance
 */
export enum ProductType {
  INDEX_V1 = 'IndexV1',
  INDEX_V2 = 'IndexV2',
  INDEX_V3 = 'IndexV3',
  STAKING = 'Staking',
}
